import * as React from "react";
const SvgMusic = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M21.047 2.738a.75.75 0 0 0-1.5 0v.25h-.25a.75.75 0 0 0 0 1.5h.25v.25a.75.75 0 0 0 1.5 0v-.25h.25a.75.75 0 0 0 0-1.5h-.25v-.25ZM4.53 18.305a.75.75 0 0 0-1.5 0v.25h-.25a.75.75 0 0 0 0 1.5h.25v.25a.75.75 0 0 0 1.5 0v-.25h.25a.75.75 0 0 0 0-1.5h-.25v-.25ZM4 11.25a2.25 2.25 0 0 1 3-2.122V4.5a.75.75 0 0 1 .487-.702l2-.75a.75.75 0 0 1 .526 1.404L8.5 5.02v6.23a2.25 2.25 0 0 1-4.5 0Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM11 15c.356 0 .694.074 1 .208V9.5a.75.75 0 0 1 .487-.702l6-2.25a.75.75 0 0 1 1.013.702v8.25a2.5 2.5 0 1 1-1.5-2.292v-2.126l-4.5 1.688v4.733A2.5 2.5 0 1 1 11 15Zm0 1.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.5-5.332L18 9.48V8.332l-4.5 1.688v1.148ZM17 14.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgMusic;
